export const WALLET_CUSTODY_TYPE = {
  CUSTODIAL: 'custodial',
  NON_CUSTODIAL: 'non_custodial',
};

export const WALLET_PROVIDER = {
  BITGO: 'bitgo',
  METAMASK: 'metamask',
};

export const NON_CUSTODIAL_CONNECTION_STATUS = {
  IDLE: 'idle',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  MISMATCH: 'mismatch',
  ERROR: 'error',
};

/** EIP-712 domain for Ondo DvP order signing — must match the on-chain settlement contract. */
export const DVP_EIP712_DOMAIN_NAME = 'OndoSettlementExchange';
export const DVP_EIP712_DOMAIN_VERSION = '1';

/** Minimal ERC-20 ABI for balance, allowance, and approve. */
export const ERC20_ABI = [
  {
    constant: true,
    inputs: [{ name: '_owner', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: 'balance', type: 'uint256' }],
    type: 'function',
  },
  {
    constant: true,
    inputs: [
      { name: '_owner', type: 'address' },
      { name: '_spender', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: 'remaining', type: 'uint256' }],
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      { name: '_spender', type: 'address' },
      { name: '_value', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: 'success', type: 'bool' }],
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', type: 'uint8' }],
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', type: 'string' }],
    type: 'function',
  },
];
